import { ApplicationFormLayout } from 'layouts';
import { OoApplicationViewPage } from 'pages/OoApplicationViewPage';

export const ApplicationDetailsPage = () => {
  return (
    <ApplicationFormLayout>
      <OoApplicationViewPage />
    </ApplicationFormLayout>
  );
};
